"use client";

import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../../api/api";
import { useAuth } from "../../../context/AuthContext";

const SignInForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await loginUser(email, password);

      console.log("LOGIN RESPONSE:", res);

      if (res && res.token && res.user) {
        // Save JWT for future requests
        localStorage.setItem("token", res.token);

        // Save user info in AuthContext
        updateUser(res.user);

        // If super admin, go to super admin panel
        if (res.role === "super_admin") {
          navigate("/super-admin/dashboard", { replace: true });
        } else {
          // Everyone else follows backend redirect
          const redirectPath = res.redirect || "/dashboard/mydashboard";
          navigate(redirectPath, { replace: true });
        }
      } else {
        alert(res.msg || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.msg || "Login failed due to server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-main-content">
      <Row className="g-0 min-vh-100">
        {/* Left side image */}
        <Col
          lg={6}
          className="d-none d-lg-flex"
          style={{
            backgroundImage: 'url("/images/signin.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(84, 82, 82, 0.5)",
            }}
          />
          <div
            style={{
              position: "relative",
              zIndex: 2,
              color: "#ffffff",
              textAlign: "center",
              maxWidth: "80%",
            }}
          >
            <h1 style={{ fontWeight: 900, marginBottom: 20, color: "#fff" }}>Time Sync</h1>
            <p style={{ fontSize: 24 }}>
              Manage projects, boost productivity, and stay organized.
            </p>
          </div>
        </Col>

        {/* Right side - login form */}
        <Col lg={6} className="d-flex align-items-center justify-content-center">
          <div className="mw-480 mx-auto w-100 px-4">
            <h3 className="fs-28 mb-4 text-center">Welcome Back</h3>

            {/* Social login placeholders */}
            <div className="row justify-content-center mb-4">
              <div className="col-lg-4 col-sm-4">
                <a
                  href="https://www.google.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                  style={{ borderColor: "#D6DAE1" }}
                >
                  <img src="/images/google.svg" alt="google" width={25} height={25} />
                </a>
              </div>
              <div className="col-lg-4 col-sm-4">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                  style={{ borderColor: "#D6DAE1" }}
                >
                  <img src="/images/facebook2.svg" alt="facebook2" width={25} height={25} />
                </a>
              </div>
              <div className="col-lg-4 col-sm-4">
                <a
                  href="https://www.apple.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                  style={{ borderColor: "#D6DAE1" }}
                >
                  <img src="/images/apple.svg" alt="apple" width={25} height={25} />
                </a>
              </div>
            </div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <label className="label text-secondary">Email Address</label>
                <Form.Control
                  type="email"
                  className="h-55"
                  placeholder="example@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <label className="label text-secondary">Password</label>
                <Form.Control
                  type="password"
                  className="h-55"
                  placeholder="Type password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              {/* <Form.Group className="mb-4">
                <Link
                  to="/authentication/forgot-password/"
                  className="fw-medium text-primary text-decoration-none"
                >
                  Forgot Password?
                </Link>
              </Form.Group> */}

              <Form.Group className="mb-4">
                <button
                  type="submit"
                  className="btn btn-primary fw-medium py-2 px-3 w-100"
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Sign In"}
                </button>
              </Form.Group>

              <Form.Group>
                <p>
                  Don’t have an account?{" "}
                  <Link
                    to="/authentication/sign-up"
                    className="fw-medium text-primary text-decoration-none"
                  >
                    Sign Up
                  </Link>
                </p>
              </Form.Group>

              <Form.Group className="mt-3 text-center">
                <a
                  href="/downloads/Time_Sync_Setup_V-1-1.exe"
                  download
                  className="btn btn-success fw-medium py-2 px-4"
                  style={{ borderRadius: "8px", fontSize: "16px" }}
                >
                  Download Time Sync
                </a>
                <p className="mt-2 text-muted" style={{ fontSize: "14px" }}>
                  Get the desktop version for faster access
                </p>
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignInForm;